import { queryOptions } from "@tanstack/react-query"
import { getSettingsOverviewStatsFn } from "@/features/settings/server/settingsOverview"
import { settingsQueryKeys } from "@/lib/queryKeys"

/**
 * Query configuration for settings overview statistics
 */
export const settingsOverviewQuery = () =>
  queryOptions({
    queryKey: settingsQueryKeys.overview(),
    queryFn: () => getSettingsOverviewStatsFn(),
  })
